import Icon from "@components/Icon";
import { colours, richTextHelper } from "@helpers";
import { mixpanelTrack } from "@helpers/mixpanel.helper";
import type { IAppModuleFields } from "@types-contentful";
import type React from "react";
import { useState } from "react";
import Slider from "react-slick";
import styled from "styled-components";
import { AppAndCTAContainer } from "./AppAndCTAContainer";
import SliderOption from "./SliderOption";
declare module "react-slick" {
	interface __config {
		className?: string;
		adaptiveHeight?: boolean;
		arrows?: boolean;
		autoplay?: boolean;
		autoplaySpeed?: number;
		centerMode?: boolean;
		centerPadding?: string;
		cssEase?: string;
		dots?: boolean;
		dotsClass?: string;
		draggable?: boolean;
		easing?: string;
		fade?: boolean;
		focusOnSelect?: boolean;
		infinite?: boolean;
		initialSlide?: number;
		lazyLoad?: boolean;
		rtl?: boolean;
		slide?: string;
		slidesToShow?: number;
		slidesToScroll?: number;
		speed?: number;
		swipe?: boolean;
		swipeToSlide?: boolean;
		touchMove?: boolean;
		touchThreshold?: number;
		variableWidth?: boolean;
		useCSS?: boolean;
		vertical?: boolean;
		afterChange?: () => void;
		beforeChange?: () => void;
		slickGoTo?: number;
	}
	interface P extends __config {
		responsive?: { breakpoint: number; settings: __config }[];
	}
}
const Container = styled.div<{
	resetModuleMarginBottom: "No" | "Yes" | undefined;
}>`
  margin-bottom: 0px !important;
  background: ${colours.PALE_PEACH};
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  .slick-slide > div {
    height: 100%;
  }
  .slick-dots {
    bottom: -25px;
    @media (min-width: 1172px) {
      bottom: -29px;
      position: absolute;
    }
  }
  @media (min-width: 1172px) {
    overflow: inherit;

    flex-direction: row;
    justify-content: center;
    gap: 250px;
    margin: 0 auto;
    align-items: inherit;
    padding: 40px 10% 0px 10%;
  }

  .slick-track {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    @media (min-width: 1172px) {
      align-items: center;
      height: 100%;
    }
  }

  .ft-slick__dots--custom {
    height: 4px;
    width: 14px;
    border-radius: 12px;
    position: relative;
  }

  .slick-dots li {
    width: 24px;
    margin: 0 2px;
    transition: width 0.3s ease-in-out;
    background-color: white;
    border-radius: 12px;
    height: 4px;
  }

  .slick-dots .slick-active {
    width: 56px;
    background-color: ${colours.MIDNIGHT_BLUE};
    height: 4px;
    border-radius: 12px;
    position: relative;
  }

  .slick-dots {
    @media (min-width: 860px) {
    }
  }

  .slick-dots .slick-active .ft-slick__dots--custom {
    width: 88px;
    top: 0px;
    overflow: hidden;
  }
`;

const PinkBottomContainer = styled.div<{
	resetModuleMarginBottom: "No" | "Yes" | undefined;
}>`
  background-color: ${colours.PEACH};
  height: 40px;
  z-index: 1;
  margin-top: 0px;
  position: relative;

  ${({ resetModuleMarginBottom }) =>
		resetModuleMarginBottom === "Yes" && "margin-bottom: 0px !important"};
  @media (max-width: 1172px) {
    display: none;
  }
`;

const ImageCarouselDiv = styled.div`
  padding: 40px 0px 0px 0px;
  /* z-index: 999; */

  @media (min-width: 1172px) {
    padding: 0px;
  }
`;
const ImageSlides = styled.img`
  width: 100%;
  /* overflow: hidden; */
  height: auto;
  object-fit: cover;
  object-position: center;
`;

const ImageDiv = styled.div`
  width: 263px;
  position: relative;
  margin: 0 auto;
  margin-top: auto;
  height: 366px;
  @media (min-width: 1172px) {
    width: 320px;
    height: 431px;
    margin-top: auto;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
  }
`;

const ContentHeader = styled.h2`
  margin-top: 72px;
  margin-bottom: 32px;

  @media (min-width: 1172px) {
    margin-top: 0px;
  }
`;

const SlidesContainer = styled.div`
  display: flex;
  flex-direction: columm;
  justify-content: space-between;
  align-items: center;
  height: 100%;

  .slick-list {
    padding: 0px;
    @media (min-width: 1172px) {
      height: 100%;
    }
  }
  .slick-slider {
    width: 330px;
    height: fit-content;
    @media (min-width: 1172px) {
      width: 345px;
      height: 100%;
    }
  }

  .slick-prev {
    @media (min-width: 860px) {
      left: -72px;
      margin-top: 52px;
    }
  }
  .slick-next {
    @media (min-width: 860px) {
      right: -72px;
      margin-top: 52px;
    }
  }
`;

const ArrowRightSpan = styled.span`
  width: 52px;
  height: 52px;
  cursor: pointer;
`;

const ArrowLeftSpan = styled.span`
  width: 52px;
  height: 52px;
  cursor: pointer;
`;

const SlideContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  justify-content: space-between;

  align-items: center;
  height: 100%;
  width: 303px;

  @media (min-width: 860px) {
    width: 456px;
    display: flex !important;
    justify-content: space-between;
    gap: 32px;
  }
`;

const ContentDiv = styled.div`
  background: linear-gradient(
    ${colours.PEACH} 0%,
    ${colours.PEACH} 5%,
    ${colours.WHITE} 5%,
    ${colours.WHITE} 100%
  );
  padding: 0px 35px 40px 35px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ol {
    width: 303px;
  }
  @media (min-width: 860px) {
    ol {
      width: 436px;
    }
  }
  @media (min-width: 1172px) {
    display: block;
    width: 466px;
    padding: 0px;
    height: 94%;
    background: ${colours.PALE_PEACH};
    ol {
      height: inherit;
      width: inherit;
    }
  }

  position: relative;
  li {
    margin-bottom: 24px;
    margin-top: 0px;
    margin-left: 0px;
    @media (min-width: 1172px) {
      margin-bottom: 32px;
      margin-top: 10px;
    }
    &:last-child {
      margin-bottom: 0px;
    }
  }

  ol > li:before {
    min-width: 24px;
    @media (min-width: 1172px) {
      min-width: 36px;
    }
    content: counter(item) "";
    font-weight: bold;
  }
`;

const TextDiv = styled.div`
  text-align: center;
  width: 100%;
  h2 {
    margin-bottom: 16px;

    @media (min-width: 860px) {
      margin-bottom: 24px;
    }
  }
  p {
    margin-bottom: 32px;
  }
`;

const iconSizes = {
	iconMobile: 52,
	iconTablet: 52,
	iconLaptop: 52,
	iconDesktop: 52,
	iconDesktopLarge: 52,
};
export interface ArrowRight {
	className?: string | undefined;
	style?: React.CSSProperties | undefined;
	onClick?: React.MouseEventHandler<HTMLDivElement>;
	currentSlide?: number | undefined;
	slideCount?: number | undefined;
}
export interface ArrowLeft {
	className?: string | undefined;
	style?: React.CSSProperties | undefined;
	onClick?: React.MouseEventHandler<HTMLDivElement>;
	currentSlide?: number | undefined;
	slideCount?: number | undefined;
}
const AppModule = ({
	name,
	removeNegativeSpacingBelowModule,
	textAndImage,
	contentHeader,
	eSimSteps,
	physicalSimSteps,
	ctaButtonLabel,
	ctaButtonUrl,
	ctaButtonColour,
	appStoreUrl,
	googlePlayUrl,
}: IAppModuleFields) => {
	const [active, setActive] = useState(0);
	const handleRadioChange = (event: { target: { id: any } }) => {
		setActive(Number(event.target.id));
	};

	function ArrowLeft(props) {
		const { className, onClick, cta_position } = props;
		return (
			<ArrowLeftSpan
				className={className}
				onClick={() => {
					mixpanelTrack("cta_arrow_click", {
						cta_position,
						cta_engagemnet: "Backward",
					});

					onClick();
				}}
				onKeyDown={onClick}
				role="button"
				aria-label="Previous"
			>
				<Icon
					style={{ cursor: "pointer" }}
					iconName="chevron-left"
					iconSizes={iconSizes}
					alt="Previous"
				/>
			</ArrowLeftSpan>
		);
	}
	function ArrowRight(props) {
		const { className, onClick, cta_position } = props;

		return (
			<ArrowRightSpan
				className={className}
				onClick={() => {
					mixpanelTrack("cta_arrow_click", {
						cta_position,
						cta_engagemnet: "Forward",
					});

					onClick();
				}}
				onKeyDown={onClick}
				role="button"
				aria-label="Next"
			>
				<Icon
					style={{ cursor: "pointer" }}
					iconName="chevron-right"
					iconSizes={iconSizes}
					alt="Next"
				/>
			</ArrowRightSpan>
		);
	}

	const resetModuleMarginBottom = removeNegativeSpacingBelowModule;

	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		nextArrow: <ArrowRight cta_position={name} />,
		prevArrow: <ArrowLeft cta_position={name} />,
		appendDots: (
			dots:
				| string
				| number
				| boolean
				| React.ReactFragment
				| React.ReactPortal
				| null
				| undefined,
		) => <ul>{dots}</ul>,
		customPaging: () => (
			<div className="ft-slick__dots--custom">
				{/* <div className="loading" /> */}
			</div>
		),
	};
	const sliderItems = [
		{
			value: "esim",
			iconName: "sim-esim",
			name: "eSIM",
			steps: eSimSteps,
		},
		{
			value: "psim",
			iconName: "sim",
			name: "Physical SIM",
			steps: physicalSimSteps,
		},
	];

	return (
		<>
			<Container resetModuleMarginBottom={resetModuleMarginBottom}>
				<ImageCarouselDiv>
					<SlidesContainer>
						<Slider {...settings}>
							{textAndImage.map((items) => (
								<SlideContent key={items.fields?.header}>
									<TextDiv>
										<h2>{items.fields?.header}</h2>
										{items?.fields?.subCopy &&
											richTextHelper(items.fields.subCopy)}
									</TextDiv>
									<ImageDiv>
										<ImageSlides
											className="clickable"
											src={items?.fields?.image?.fields?.file?.url}
											alt={
												items?.fields?.image?.fields?.description !== ""
													? items?.fields?.image?.fields?.description
													: items.fields?.header
											}
											loading="lazy"
										/>
									</ImageDiv>
								</SlideContent>
							))}
						</Slider>
					</SlidesContainer>
				</ImageCarouselDiv>
				<ContentDiv>
					<ContentHeader>{contentHeader}</ContentHeader>
					<SliderOption
						page_name={ctaButtonUrl}
						cta_position={name}
						marginBottom={{ mobile: "40px", desktop: "56px" }}
						active={active}
						handleRadioChange={handleRadioChange}
						sliderItems={sliderItems}
					/>
					<div>
						<ol>
							{sliderItems[active].steps &&
								sliderItems[active].steps.map((item, index) => (
									<li key={index + index}>{item}</li>
								))}
						</ol>
					</div>
					<AppAndCTAContainer
						ctaButtonUrl={ctaButtonUrl}
						ctaButtonColour={ctaButtonColour}
						name={name}
						ctaButtonLabel={ctaButtonLabel}
						googlePlayUrl={googlePlayUrl}
						appStoreUrl={appStoreUrl}
						bgColor={"White"}
						bgColorDesktop={"Pale Peach"}
						marginBottom="56px"
					/>
				</ContentDiv>
			</Container>
			<PinkBottomContainer resetModuleMarginBottom={resetModuleMarginBottom} />
		</>
	);
};

export default AppModule;
